<template>
    <div class="estate-card-data">
        <div v-if="estate.rooms" class="estate-card-data-element estate-card-rooms">
            <slot name="estate-rooms">
                <masked-image src="/img/icons/rooms.svg"></masked-image>
                <span v-if="estate.rooms_short" v-html="estate.rooms_short"></span>
                <span v-else v-html="estate.rooms"></span>
            </slot>
        </div>

        <div v-if="estate.bedrooms_small" class="estate-card-data-element estate-card-rooms">
            <slot name="estate-rooms">
                <masked-image src="/img/icons/rooms.svg"></masked-image>
                <span v-html="estate.bedrooms_small"></span>
            </slot>
        </div>

        <div v-if="estate.surface" class="estate-card-data-element estate-card-surface">
            <slot name="estate-surface">
                <masked-image src="/img/icons/surface.svg"></masked-image>
                <span v-html="estate.surface"></span>
            </slot>
        </div>

        <div v-if="estate.solutions_count" class="estate-card-data-element estate-card-solutions">
            <slot name="estate-solutions">
                <masked-image src="/img/icons/solutions.svg"></masked-image>
                <span v-html="estate.solutions_count"></span>
            </slot>
        </div>

        <div v-if="estate.bathrooms" class="estate-card-data-element estate-card-bathrooms">
            <slot name="estate-bathrooms">
                <masked-image src="/img/icons/bathrooms.svg"></masked-image>
                <span v-html="estate.bathrooms"></span>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        estate: {
            type: Object,
            required: true,
        },
    },
}
</script>